<template>
    <div class="wrapper">
        <!-- TO DO: Have to add skeletons and add logic of waiting data -->
        <ContentImageBlock
            v-if="infoBlock"
            :titleData="titleData"
            :data="infoBlock"
            :isDarkTheme="isDarkTheme"
        />
        <IconList
            v-if="iconCardBlock"
            :titleData="titleData"
            :data="iconCardBlock"
            :isDarkTheme="isDarkTheme"
        />
        <NumberList
            v-if="numericBlock"
            :titleData="titleData"
            :data="numericBlock"
            :isDarkTheme="isDarkTheme"
        />
        <CustomContent
            v-if="customContentBlock"
            :titleData="titleData"
            :data="customContentBlock"
            :isDarkTheme="isDarkTheme"
        />
    </div>
</template>

<script>
import VueTypes, { nullable } from 'vue-types';
import { InfoBlock, IconCardBlock, NumericBlock, CustomContentBlock, TitleSettings } from './types';
import { themes, defaultTheme } from './types'

export default {
    name: 'InfoSection',
    computed: {
        isDarkTheme() { return this.theme === 'dark' ? true : false },
    },
    components: {
        ContentImageBlock: () => import('./components/ContentImageBlock'),
        NumberList: () => import('./components/NumberList'),
        IconList: () => import('./components/IconList'),
        CustomContent: () => import('./components/CustomContent')
    },
    props: {
        titleData: TitleSettings,
        infoBlock: VueTypes.oneOfType([InfoBlock, nullable]).def(null),
        iconCardBlock: VueTypes.oneOfType([IconCardBlock, nullable]).def(null),
        numericBlock: VueTypes.oneOfType([NumericBlock, nullable]).def(null),
        customContentBlock: VueTypes.oneOfType([CustomContentBlock, nullable]).def(null),

        theme: VueTypes.oneOf(themes).def(defaultTheme),
    }
};
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
